module.exports = __webpack_public_path__ + "static/media/vin_logo.636d0640.svg";